import apiClient from '../lib/api-client';

export interface UserPermission {
  user_id: string;
  permissions: string[];
  roles: string[];
}

export interface PermissionUpdateRequest {
  permissions: string[];
  roles: string[];
}

class PermissionService {
  private readonly baseUrl = '/permissions';

  async getUserPermissions(userId: string): Promise<UserPermission> {
    const response = await apiClient.get(`${this.baseUrl}/user/${userId}`);
    return response.data;
  }

  async updateUserPermissions(userId: string, data: PermissionUpdateRequest): Promise<UserPermission> {
    const response = await apiClient.put(`${this.baseUrl}/user/${userId}`, data);
    return response.data;
  }

  async getAvailablePermissions(): Promise<string[]> {
    const response = await apiClient.get(`${this.baseUrl}/available`);
    return response.data;
  }

  async getAvailableRoles(): Promise<string[]> {
    const response = await apiClient.get(`${this.baseUrl}/roles`);
    return response.data;
  }

  async bulkUpdatePermissions(updates: Array<{ userId: string; data: PermissionUpdateRequest }>): Promise<UserPermission[]> {
    const response = await apiClient.post(`${this.baseUrl}/bulk-update`, { updates });
    return response.data;
  }
}

export const permissionService = new PermissionService();
export default permissionService;
